import { TabPanelType } from 'utils/consts';


const chatStoreInitialState = {
  isChatShown: true,
  isChatAuthenticated: false,
  initialMessagesSet: false,
  isInteractionShown: false,
  isEmojiPickerVisible: false,
  chatInputValue: '',
  messages: [],
  privateMessages: [],
  privateChats: {},
  groupShowMessages: [],
  isMobileKeyboardActive: false,
  initialWindowHeight: window.innerHeight,
  windowHeight: window.innerHeight,
  scrollToBottom: false,
  isPrivateMessageOpen: false,
  hasUnreadMessages: false,
  hasPrivateUnreadMessages: false,
  lastPrivateMessageTimestamp: 0,
  lastChatMsgKey: '',
  lastChatMsgTimeStamp: '',
  translationSettings: {
    active: false,
    languageCode: null,
    showOriginalLanguage: false,
  },
  isGold: false,
  chatSettings: { stealthModeValue: 'visible' },
  chatSettingsPerformer: {},
  isPrivateShowChatShown: true,
  profileChatTabValue: 0,
  isChatInputErrorVisible: false,
  chatInputErrorMessage: '',
  privateChatSessionData: {},
  conversations: {},
  activeConversation: null,
  activeReadConversations: {},
  hiddenChats: [],
  gsChatOpen: false,
  hasUnreadGsMessages: false,
  goalDrawer: false,
  tipNotifications: [],
  isForeignLanguagesTresholdReached: false,
  lastTippingToastNotificationTimestamp: 0,
  activeBroadcasterChatTab: TabPanelType.publicChat,
  consecutiveNumOfInvalidRoom: 0,
  consecutiveNumOfPrivateInvalidRoom: 0,
  consecutiveNumOfGroupInvalidRoom: 0,
  isScrollAtBottom: true,
};

export default chatStoreInitialState;
